import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiClient } from '@app/core/services/base-api-client.service';
import { LoadingIndicatorService } from '@app/core/services/loading-indicator.service';
import { LogService } from '@app/core/services/log.service';
import { Environment } from '@env/environment';
import { catchError, Observable, tap } from 'rxjs';
import { Announcement } from '../models/announcement';

const httpOptions = {
	headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};
export interface IAnnouncementService {
	url: string;
	getRSSSystemList(): Observable<Announcement[]>;
}
@Injectable({
	providedIn: 'root',
})
export class AnnouncementService extends BaseApiClient implements IAnnouncementService {
	/**
	 * The base URL for the API domain.
	 */
	public baseUrl: string;

	/**
	 * The URL to the API endpoint.
	 */
	public url: string;

	constructor(
		private readonly http: HttpClient,
		private readonly log: LogService,
		private readonly loadingIndicatorService: LoadingIndicatorService,
		environment: Environment
	) {
		super();
		this.baseUrl = environment.services['employee'];
		this.url = this.baseUrl + 'RSSFeed';
	}

	/**
	 * Get Announcements
	 */
	getRSSSystemList(): Observable<Announcement[]> {
		const url = `${this.url}/RSSSystemList`;
		const errorHandler = this.createErrorResponseHandler(this.log, undefined, (_) => this.loadingIndicatorService.stopLoading());

		this.loadingIndicatorService.startLoading();
		return this.http.get<Announcement[]>(url, httpOptions).pipe(
			tap((result) => {
				this.loadingIndicatorService.stopLoading();
			}),
			catchError(errorHandler)
		);
	}
}
